const SHINE = 'shine'

export const isBankShine = (bankName: string): boolean => {
  return bankName.toLowerCase() === SHINE
}
